import type { ReactNode } from 'react'

import { Textarea } from '@/components/ui/textarea'
import { ContentBriefEditorActions } from './content-brief-editor-actions.atom'

export interface ContentBriefBlockEditorProps {
  draftComment: string
  hasComment: boolean
  textareaRef: React.RefObject<HTMLTextAreaElement | null>
  onDraftChange: (value: string) => void
  onKeyDown: (e: React.KeyboardEvent) => void
  onSave: () => void
  onCancel: () => void
  onDelete: () => void
}

const stopPropagation = (e: React.MouseEvent): void => {
  e.stopPropagation()
}

const createClickHandler =
  (handler: () => void) =>
  (e: React.MouseEvent): void => {
    e.stopPropagation()
    handler()
  }

export const ContentBriefBlockEditor: React.FC<ContentBriefBlockEditorProps> = ({
  draftComment,
  hasComment,
  textareaRef,
  onDraftChange,
  onKeyDown,
  onSave,
  onCancel,
  onDelete,
}): ReactNode => (
  <div className="content-brief-block-editor border-t border-primary/20 px-3 py-2">
    <Textarea
      ref={textareaRef}
      value={draftComment}
      onChange={(e) => onDraftChange(e.target.value)}
      onKeyDown={onKeyDown}
      onClick={stopPropagation}
      placeholder="Add your feedback for this section..."
      className="content-brief-comment-input min-h-20 resize-none border-0 bg-transparent p-0 text-sm shadow-none focus-visible:ring-0"
    />
    <ContentBriefEditorActions
      hasComment={hasComment}
      onSave={createClickHandler(onSave)}
      onCancel={createClickHandler(onCancel)}
      onDelete={createClickHandler(onDelete)}
    />
    <p className="mt-1 text-xs text-muted-foreground">Cmd+Enter to save, Esc to cancel</p>
  </div>
)
